export const useStyles = theme => ({
  eventClosed: {
    height: '100%',
    flexWrap: 'wrap',
    alignContent: 'flex-start',
    alignItems: 'center',
    justifyContent: 'center',
    alignContent: 'center',
    display: 'flex',
    [theme.breakpoints.down('sm')]: {
      width: '95%',
      margin: 'auto',
    },
  },
});
